import {Component} from 'react';
import "./ExtraCredit/extraCredit.css";
import "../../css/styles.css";
import { connect } from 'react-redux';
import { setInfo, setGameData } from '../../redux/actionList';
import TestQuestionAnswers from './test_question_answers';
import TestButtonDisplay from './test_button_display';
import { buildUrl} from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import MoneyMgmtJokes from './Datasets/money_mgmt_jokes';
import calcRandomNumberWithMax from '../../objects/CommonUse/calc_random_number_with_max';
import createTestQuestionList from './objects/create_test_questionList';
import checkIfTestUnlocked from './objects/check_if_test_unlocked';
import buildTestTypeArr from '../../objects/CommonUse/build_test_type_arr';
import InformationModal from '../shared-components/information_modal';
import calcTestScore from './objects/calc_test_score';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    gameData: state.gameData,
    accountSettings: state.accountSettings,
    prevProcess: state.prevProcess,
    moneyMgmtTestArr: state.moneyMgmtTestArr
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
    setGameDataRedux: setGameData
};

class MoneyMgmtConceptTest extends Component {
  constructor(props) {
    super(props);
    this.state={  
        warningMsg: false,
        nextButton: true,
        slctDone: false,
        animationComplete: true,
        displayResults: false,
        jokeResponse: false,
        subProcess: "MoneyMgmtTest",
        environment: Config.dataURL.currentEnv,
        headers: setHeadersForFetch(),
        openInformationModal: false,
        rerender: false
    }    
    this.allJokesArr = MoneyMgmtJokes;
    this.questionNbr = 0;
    this.jokeQuestionNbrArr = [2, 4, 7, 8, 10];
    this.buttonText = "Start";
    this.buttonText2 = "none";
    this.errorMsg = "";
    this.answerSet = false;
    this.testQuestions = createTestQuestionList();  
    this.totalNbrQuestions = this.testQuestions.length;
    this.determineJokeNbrs();
}

determineJokeNbrs(){
    const jokeLength = this.allJokesArr.length;
    this.jokeArr = [];
    while (this.jokeArr.length <= this.jokeQuestionNbrArr.length){
        let randomNbr = calcRandomNumberWithMax(jokeLength, true);
        if (this.jokeArr.includes(randomNbr)){
            //  this random number is already in the array
        }else{
            this.jokeArr.push(randomNbr);
        }
    }
}

getNextQuestion(buttonText){
    switch (buttonText){
        case "Return to HomePage":
            this.props.onNavigate("");
            break;
        case "Return to Game":
            if (this.previousProcess === ""){
                this.previousProcess = "game-board";
            }
            this.props.onNavigate(this.previousProcess);
            break;
        case "Finish":
             this.finishTest();
             break;
        default:
            this.questionNbr += 1;
            if (this.questionNbr === this.totalNbrQuestions){
                this.buttonText = "Finish";
            }else{
                this.buttonText = "Next";
            }
            this.setQuestionText();
            break;
    }
      
}

getPreviousQuestion(){
    this.questionNbr = this.questionNbr - 1;
    this.displayJoke = true;
    this.setQuestionText();
}

setQuestionText(){
    this.determineIfJoke();
    let indx = this.questionNbr - 1;
    this.questionObj = this.testQuestions[indx];
    const answerObj = this.questionObj.answerList.find(elem => elem.checked === true);
    if (this._isMounted === true){
        if (answerObj){
            this.setState({nextButton: true});
        }else{
            this.setState({nextButton: false});
        }
    }
}

determineIfJoke(){
    this.displayJoke = false;
    for (let i=0; i<this.jokeQuestionNbrArr.length; i++){
        if (this.jokeQuestionNbrArr[i] === this.questionNbr){
            const jokeIndx = this.jokeArr[i];
            this.jokeObj = this.allJokesArr[jokeIndx];
            this.displayJoke = true;
        }
    }
    if (this._isMounted === true){
        this.setState({jokeResponse: false});
    }
}

answerSelected(answerObj){
    // reset the answer list so all entries are false if only 1 answer is allowed
    if (this.questionObj.answerType === "single"){
        for (let i=0; i<this.questionObj.answerList.length; i++){
            this.questionObj.answerList[i].checked = false;
        }
    }
    let answer = answerObj.answer;
    const answerIndx = this.questionObj.answerList.findIndex(elem => elem.answer === answer);
    this.questionObj.answerList[answerIndx].checked = answerObj.checked;
    this.answerError = false;
    this.errorMsg = "";
    this.editAnswerArr();
    if (this._isMounted === true){
        if (this.answerError === false){
            this.answerSet = true;
            this.setState({nextButton: true});
        }else{
            this.setState({nextButton: false});
        }
    }
    
}

editAnswerArr(){
  let answerCount = 0;
  for (let i=0; i<this.questionObj.answerList.length; i++){
       let answerList = this.questionObj.answerList[i];
       if (answerList.checked === true){
            answerCount += 1;
       }
  }
  if (answerCount === 0){
      this.answerError = true;
      this.errorMsg = "You Must Select at least 1 answer.";
  }
  if (this.answerError === false){
      if (this.questionObj.answerType === "single" && answerCount > 1){
          this.answerError = true;
          this.errorMsg = "Only 1 answer can be selected for this question.";
      }
  }
}

finishTest(){
    //  'grade' test and save to mongodb - save questions, answers and correct/incorrect
    this.gradeTest();
    this.saveTestResults();
    this.checkIconTable();
    this.questionNbr = 99;
    this.buttonText = "Return to HomePage";
    if (this.userRole === "demo"){
        this.buttonText2 = "none";
    }else{
        this.buttonText2 = "Return to Game";
    }
    if (this._isMounted === true){
        this.setState({displayResults: true});
    }
}

gradeTest(){
    // calcTestScore determines total percent correct but also appends the pct correct
    // for each question in this.testQuestions
    const calcTestObj = calcTestScore(this.testQuestions);
    this.pctCorrect = calcTestObj.pctCorrect;
    this.nbrCorrect = calcTestObj.nbrCorrect;
    this.starClass = "super-star-info";
    if (+this.pctCorrect >= 90){
        this.starClass = this.starClass + " star-spin-around"
    }
    this.setFinishComment();
    this.pctCorrect = this.pctCorrect + "%";
}

checkIconTable(){
    const gameData = this.props.gameData;
    this.iconTable = gameData.iconTable;
    if (this.iconTable){
        let iconIndx = this.iconTable.findIndex(elem => elem.iconName === "takeMoneyMgmtTest");
        if (iconIndx !== -1){
            this.iconTable.splice(iconIndx,1);
            this.updateIconTable();
        }
    }
}

setFinishComment(){
    switch (true){
        case (this.pctCorrect >= 90):
            this.comment = "You did an amazing job, you are definitely a Financial Literacy Superstar!!";
            break;
        case (this.pctCorrect >= 80):
            this.comment = "You did a great job, you are well on your way to being a Financial Literacy Superstar!!"
            break;
        case (this.pctCorrect >= 60):
            this.comment = "You did a good job, keep playing the game and you will become a Financial Literacy Superstar."
            break;
        default:
            this.comment = "You did not do very well on the test this time, but keep playing the game and you will " +
                "become a Financial Literacy Superstar.";
            break;
    }
    let checkNbr = (+this.nbrCorrect).toFixed(0);
    this.partialCredit = false;
    if (this.nbrCorrect !== checkNbr){
        this.partialCredit = true;
    }
}

setAnimationComplete(){
    if (this._isMounted === true){
        this.setState({animationComplete: true});
    }
}


getJokeQuestion(){
    if (this._isMounted === true){
        this.setState({jokeResponse: false});
    }
}

getJokeResponse(){
    if (this._isMounted === true){
        this.setState({jokeResponse: true});
    }
}

closeInformationModal(){
    this.setState({openInformationModal: false});
}

render() {
        
    const infoNbrSeconds = null;
return <>
    <div className="col-8">
        <div className="card mb-0 rounded-corners-lg height-max">
            <button className="pages-back-button ml-4 mt-4" 
                onClick ={()=> this.props.goBack()}>
                            Back
            </button>
        <h3 className="mt-0 text-center">Extra Credit</h3>
        <h4 className="text-center">Are You Financially Savvy?</h4>
     
        <span>
            <div>
                {!this.state.displayResults ?
                    <span>
                        {this.questionNbr > 0  ?
                            <span>
                                <TestQuestionAnswers
                                    testQuestion = {this.questionObj}
                                    displayJoke={this.displayJoke}
                                    jokeResponse={this.state.jokeResponse}
                                    jokeObj={this.jokeObj}
                                    onSelect={(answerObj)=> this.answerSelected(answerObj)}
                                    getJokeQuestion={()=> this.getJokeQuestion()}
                                    getJokeResponse={()=> this.getJokeResponse()}
                                
                                />
                                <div className="text-right font-weight-bold mr-4 mb-2">
                                    Question Nbr {this.questionNbr} / {this.totalNbrQuestions} Total Questions
                                </div>
                            </span>
                   
                        :   
                            <span className="row">
                                <div className="col-sm-8 mt-4">
                                    <div className="medium-large-text ml-4"><b>Current Test Type: </b>
                                        {this.testType}
                                    </div>
                                    {this.testUnlocked  ?
                                        <div className="ml-4">
                                            <div className="mt-1 text-white">blank</div>
                                            <div>
                                                <b> How much do you know about financial literacy?</b>
                                            </div>
                                            <div>
                                                There are just {this.testQuestions.length} questions in this 
                                                assessment.
                                            </div>
                                            <div>
                                                Click on the "Start" button to begin.
                                            </div>
                                            <div className="mt-2 text-white">blank</div>
                                        </div>
                        
                                    :
                                        <div className="ml-4">
                                            <div className="mt-1 text-white">blank</div>
                                            You have already taken the {this.testType}.  So the 
                                            Financial Literacy Test is not available.
                                            <div className="mt-1 text-white">blank</div>
                                            {this.individual  ?
                                                <div>
                                                   Both pre-test and post-test have been completed.
                                                   You can send email to game administrator (via contact
                                                   us) if you would like to unlock the test.
                                                </div>
                                            :
                                                 <div>
                                                    If the test should be available, it can be
                                                    unlocked by asking the teacher (or parent) to change
                                                    account settings. <br/>
                                                    (Home Page -- For Teacher Parent -- Players and Settings)
                                                </div>
                                            }
                                        </div>
                                    
                                    }
                               
                                </div>
                                <div className="col-sm-4 mt-2">
                                    <img className="super-star-info2"
                                        src="./assets/testPictures/superStar.png"  alt="superStar"
                                    />
                                </div>
                            </span>
                        }
                    </span>
                :           
                    <span className="row mt-4">
                        <div className="col-sm-6 mt-4 ml-4">
                            <div><b>Total Questions correct:</b> {this.nbrCorrect}</div>
                            <div><b>Percentage Correct:</b>&nbsp;&nbsp;&nbsp; {this.pctCorrect}</div>
                            {this.partialCredit ?
                                <div className="font-weight-bold mt-4">
                                    Note:  You have received partial credit for some of the questions with
                                    multiple answers.
                                </div>
                            :
                                null
                            }
                            <div className="font-weight-bold mt-4">{this.comment}</div>
                          
                        </div>
                        <div className="col-sm-4 mt-4">
                            <img className={this.starClass} style={{opacity: this.pctCorrect}}
                                    src="./assets/testPictures/superStar.png"  alt="superStar"
                                    />
                        </div>
                    </span>
                }
            </div>
          
            <div className="text-danger font-weight-bold mt-0">{this.errorMsg}</div>
            {this.testUnlocked  ?
                <TestButtonDisplay
                        questionNbr={this.questionNbr}
                        answerSet={this.answerSet}
                        nextButton={this.state.nextButton}
                        buttonText={this.buttonText}
                        buttonText2={this.buttonText2}
                        onSubmit={()=>this.answerSubmitted()}
                        getNextQuestion={(buttonText)=> this.getNextQuestion(buttonText)}
                        getPreviousQuestion={()=> this.getPreviousQuestion()}
                />
            :
                null
            }

            {this.state.openInformationModal   ?
                <InformationModal   
                    time={infoNbrSeconds}
                    gotItBtn={true}
                    show={this.state.openInformationModal}
                    infoCode={this.informationCode}
                    onClose={() => this.closeInformationModal()}
                />
            :
                null
            }
      
            </span>
            
        </div>
     </div>
  </>
}

componentDidMount(){
    this._isMounted = true;
    const accountSettings = this.props.accountSettings;
    let testSettings="";
    this.individual = true;
    this.userRole = sessionStorage.getItem("userRole");
    if (accountSettings){
         testSettings = accountSettings.testSettings;
         this.individual = false;
    }
    const testCheckObj = checkIfTestUnlocked(testSettings, this.individual, this.props.moneyMgmtTestArr);
    if (this.userRole === "demo"){
        this.testType = "mid-test";
        this.testUnlocked = true;
    }else{
        this.testType = testCheckObj.testType;
        this.testUnlocked = testCheckObj.testUnlocked; 
    }
   
    this.previousProcess = this.props.prevProcess;
    if (this.previousProcess === "" && testSettings.testType === "pre-test"){
        this.informationCode = "RedirectToTest";
        this.setState({openInformationModal: true})
    }else{
        this.setState({rerender: true});
    }
}

componentWillUnmount(){
    this._isMounted = false;
}

saveTestResults(){
    this.buildQuestionAnswerArr();
    let gameNbrMonths = this.props.totalGameMonthsPlayed.toString();
    let nbrGames = 0;
    if (this.props.totalGameMonthsPlayed > 0){
        nbrGames = (+this.props.nbrGames);
    }
    nbrGames = +nbrGames.toString();
    const user = sessionStorage.getItem("username");
    let testVersion = "1.0";
    let nbrCorrect = this.nbrCorrect.toString();
    let nbrQuestions = (this.testQuestions.length).toString();
    const bodyObj = {user: user, testVersion: testVersion, nbrGames: nbrGames, gameNbrMonths: gameNbrMonths,
                     nbrCorrect: nbrCorrect, nbrQuestions: nbrQuestions, 
                     questionAnswerArr: this.questionAnswerArr, testType: this.testType
                    };
    const funcName = "saveFinancialLiteracyTest";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
         {method:'POST', 
          headers: this.state.headers,
          body: JSON.stringify(bodyObj)})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const testArr = [output.body];
                        const moneyMgmtTestArr = buildTestTypeArr(testArr);
                        this.props.setInfoRedux(moneyMgmtTestArr, "moneyMgmtTestArr");
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                           // update was successful");
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: bodyObj};
                            this.props.processError(errorObj);
                        }
                    });
                };
            });
}

updateIconTable(){
        this.props.setGameDataRedux(this.iconTable, "iconTable");
        this.bodyObj = {
            "iconTable": this.iconTable
        };
        const funcName = "updateIconTable";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,
            {method:'PUT', headers: this.state.headers,
            body: JSON.stringify(this.bodyObj)})
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                   //  update of gameData successful
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
    }


buildQuestionAnswerArr(){
   this.questionAnswerArr = []; 
   for (let i=0; i<this.testQuestions.length; i++){
        let answerArr = [];
        const question = this.testQuestions[i];
        let nbrRightAnswers = 0;
        for (let j=0; j<question.answerList.length; j++){
            if (question.answerList[j].checked === true){
                const answerObj = {answer: question.answerList[j].answer, 
                    correct: question.answerList[j].correct};
                answerArr.push(answerObj);
            }
            if (question.answerList[j].correct === true){
                nbrRightAnswers += 1;
            }
        }
        let questionObj = {questionNbr: question.questionNbr, text: question.questionText, 
            nbrRightAnswers: nbrRightAnswers, answerArr: answerArr, correct: question.answerCorrectPct}
        this.questionAnswerArr.push(questionObj);
   }
}

}

  export default  connect(mapStateToProps, mapDispatchToProps) (MoneyMgmtConceptTest);